import { P2GBox, P2GGrid, P2GTextField, P2GText } from '@parcel2go/core-ui';
import { useState } from 'react';
import { Customer } from '~/lib/api/smartsend/types';
import { ToInlineCommaList } from '../../../lib/helpers/StringHelper';
import AlertWithIcon from '../../AlertWithIcon';
import { PanelButtons } from '../panels/PanelButtons';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  affected: number;
  customer: { Phone?: string; Email?: string };
  confirm?: (customer: Customer) => void;
  cancel?: () => void;
}

export default function ApplyRecipientContactDetails(props: props) {
  const [customer, setCustomer] = useState<Customer>({ ...props.customer } as Customer);
  const changes = [customer.Phone && 'phone', customer.Email && 'email'].filter((x) => !!x);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  return (
    <P2GBox textAlign="center">
      <P2GBox mt={2}>
        <P2GGrid container spacing={2} alignItems="center">
          <P2GGrid item xs={6}>
            <P2GTextField
              fullWidth
              validationOnFocus={false}
              value={customer.Email}
              type="email"
              onChange={(x) => setCustomer({ ...customer, Email: x.currentTarget.value })}
              label={t('EMAIL_INPUT_LABEL', { defaultValue: 'Email' })}
            />
          </P2GGrid>
          <P2GGrid item xs={6}>
            <P2GTextField
              fullWidth
              validationOnFocus={false}
              value={customer.Phone}
              type="tel"
              onChange={(x) => setCustomer({ ...customer, Phone: x.currentTarget.value })}
              label={t('PHONE_INPUT_LABEL', { defaultValue: 'Phone' })}
            />
          </P2GGrid>
        </P2GGrid>

        {changes.length > 0 && (
          <>
            <P2GBox textAlign="left" mt={2}>
              <AlertWithIcon>
                {changes.length === 2 ? (
                  <P2GText>
                    {t('PHONE_EMAIL_CHANGE_ALERT', { defaultValue: 'Both the phone and email will be changed.' })}
                  </P2GText>
                ) : (
                  <P2GText>
                    {t('PHONE_EMAIL_CHANGE_ALTERNATIVE_ALERT', {
                      defaultValue: 'Only {{changes}} will be changed.',
                      changes: ToInlineCommaList(changes)
                    })}
                  </P2GText>
                )}
              </AlertWithIcon>
            </P2GBox>
          </>
        )}

        <P2GBox mt={2} />
        <PanelButtons
          onSave={() => props.confirm(customer)}
          onCancel={props.cancel}
          cancelText={t('CANCEL_BUTTON', { defaultValue: 'Cancel' })}
        />
      </P2GBox>
    </P2GBox>
  );
}
